export enum FichierOperationStatutEnum {
  created = 'created', //1 --created
  nonCompliant = 'nonCompliant', //11 -- nonCompliant
  updatedByConsulant = 'updatedByConsultant', //5 --updatedByConsultant
  compliant = 'compliant', //21 --compliant
}
